import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { Select } from '@/domain/mitarbeiter/features/rotationsplan/features/components/Select';
import { useStandortgruppe } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useStandortgruppen/useStandortgruppen';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useTranslation } from 'react-i18next';

export function StandortSelect({
  handleChange,
  value,
}: {
  handleChange: (standort: Standort) => void;
  value: Standort;
}) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { standortGruppe } = useStandortgruppe(
    currentStandort.idStandortgruppe,
  );
  const standorte = standortGruppe?.standorte ?? [];

  return (
    <Select<Standort>
      onChange={handleChange}
      drawerLabel={t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.fields.standort.label',
      )}
      selectedOption={value}
      options={standorte}
      renderListItem={(standort) => (
        <div className="whitespace-nowrap truncate text-sm font-normal">
          {standort.storenummer && standort.storenummer.length > 0
            ? standort.storenummer + ' - ' + standort.name
            : standort.name}
        </div>
      )}
    />
  );
}
